import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagerComponent } from './pager.component';
import { PagerModule } from './pager.module';
/**
 * NgModule definition for the Pager component with providers.
 */
export class PagerAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, PagerModule],
    exports: [
        PagerModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PagerAllModule_tsickle_Closure_declarations() {
/** @type {?} */
PagerAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PagerAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
